<section class="site-search-main-wrap" appIntersectionObserver>
    <div class="container">
        <div class="site-report-main">
            <div class="row">
                <div class="col-md-5 col-sm-12 column-inner hidden delay-3">
                    <div class="site-report-main-img">
                        <img src="images/svg/where-do-we-search.svg" alt="work with only the best Image" />
                    </div>
                </div>
                <div class="col-md-7 col-sm-12 column-inner">
                    <div class="site-report-main-content">
                        <div class="site-common-heading hidden delay-1">
                            <h2 class="site-heading-h2">Where do we search?</h2>
                        </div>
                        <div class="site-report-main-content-text hidden delay-2">
                            <p class="site-text-p">
                                Individuals around the world leave extensive digital footprints through social media and
                                online
                                interactions. Our analysts ethically identify and verify relevant open-source data,
                                combining OSINT and
                                human validation to produce a fully documented report.
                            </p>
                            <p class="site-text-p">
                                Depending on the type of report requested, we have access to hundreds of compliant
                                databases worldwide
                                and utilize established on-the-ground HUMINT resources to gather information that may
                                not be accessible
                                online in certain jurisdictions. These can include court records, property ownership
                                details, marriage
                                and death certificates, and other relevant documents, where they are legally available.
                            </p>
                        </div>
                        <div class="site-reports-btns hidden delay-4">
                            <div class="site-common-btn" (click)="crossComponentService.openIllustratedModal()">
                                <a href="javascript:void(0)" class="site-btn">Request Illustrated
                                    Deep Report</a>
                            </div>
                            <div class="site-common-btn hidden delay-5" routerLink="/order-deep-report/new">
                                <a class="site-btn">Order Your Report Now</a>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</section>

@if (crossComponentService.illustratedModal()) {
<app-illustrated-modal />
}